export default __webpack_public_path__ + "static/SharpGroteskBoldItalic15-Regular-a5451ffc544d2996b29b16ab3deb292c.woff";